import * as API from "@/services/API";
import { RecordIdentifier } from "@/data/global";

export default {
    getAppointment(appointmentId: number) {
        return API.apiClient.get(`/user/appointment/${appointmentId}`);
    },
    getOpenAppointment(appointmentId: number) {
        return API.apiClient.get(`/appointment/${appointmentId}`);
    },
    getAppointmentEnrollmentStatus(appointmentId: RecordIdentifier) {
        return API.apiClient.get(`/user/appointment/${appointmentId}/enrollment/status`);
    },
    getAppointmentEnrollmentIntent(appointmentId: RecordIdentifier) {
        return API.apiClient.get(`/user/appointment/${appointmentId}/enrollment`);
    },
    enrollAppointment(appointmentId: RecordIdentifier) {
        return API.apiClient.post(`/user/appointment/${appointmentId}/enrollment`);
    },
    withdrawAppointment(appointmentId: RecordIdentifier) {
        return API.apiClient.delete(`/user/appointment/${appointmentId}/enrollment`);
    },
    joinAppointmentWaitlist(appointmentId: RecordIdentifier) {
        return API.apiClient.post(`/user/appointment/${appointmentId}/enrollment/waitlist`);
    },
    leaveAppointmentWaitlist(appointmentId: RecordIdentifier) {
        return API.apiClient.delete(`/user/appointment/${appointmentId}/enrollment/waitlist`);
    },

    getAppointmentEnrollmentBatchStatus(appointmentIds: RecordIdentifier[]) {
        return API.apiClient.post(`/user/appointment/enrollment/status`, { appointments: appointmentIds });
    },
}
